const ru = {
  title: 'Подкаст о проекте',
  source: 'Источник',
  link: 'https://itanalyst.mave.digital/ep-16?utm_source=embed',
  podcastLink:
    'https://mavecloud.s3mts.ru/storage/podcasts/57102ebf-d59d-46a0-a8a7-7df6404bed79/episodes/eaff772d-b1d5-4b18-a4c1-64f69d4b5a0f.mp3',
};

export default ru;
